import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from 'axios'
import Vuex from 'vuex'
import store from './store'

import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

import PageLoader from './components/Common/pageLoader'
import ImageLoader from './components/Common/imageLoader'
import ServerError from './components/Common/500'
import Logo from './components/Common/logo'
import SnackBar from './components/Common/snackBar'
import VueElementLoading from 'vue-element-loading'
import Viewer from 'v-viewer'
import Vue2Editor from "vue2-editor";
import JsonExcel from "vue-json-excel";
// import 'apexcharts/dist/apexcharts.min'
import VueApexCharts from 'vue-apexcharts'
import 'viewerjs/dist/viewer.css'
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import HighchartsVue from 'highcharts-vue';

Vue.use(HighchartsVue);
Exporting(Highcharts);

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.component('VueElementLoading', VueElementLoading)
Vue.use(Viewer)
Vue.use(Vue2Editor);
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('PageLoader', PageLoader)
Vue.component('ImageLoader', ImageLoader)
Vue.component('ServerError', ServerError)
Vue.component('Logo', Logo)
Vue.component('SnackBar', SnackBar)
Vue.component('VueElementLoading', VueElementLoading)
Vue.component("downloadExcel", JsonExcel);
import OwlCarousel from 'vue-owl-carousel'
Vue.component('OwlCarousel', OwlCarousel)
window.axios = require('axios')

import VueTimeago from 'vue-timeago'

Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en', // Default locale
  // We use `date-fns` under the hood
  // So you can use all locales from it
  locales: {
    'zh-CN': require('date-fns/locale/zh_cn'),
    ja: require('date-fns/locale/ja')
  }
})


// import VueSocketIO from 'vue-socket.io';
// import socket from 'socket.io-client'
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection:socket("http://192.168.53.162:3050"),
//   vuex: {
//     store,
//       actionPrefix: 'SOCKET_',
//       mutationPrefix: 'SOCKET_'
//   },
//   autoConnect:true

// }))



Vue.use(Vuex)

Vue.config.productionTip = false



window.axios = require('axios')

// axios.defaults.baseURL = 'http://localhost:3050'
// Vue.prototype.baseURL = "http://localhost:3050"
// Vue.prototype.mediaURL = "http://localhost:3050/u/"
// Vue.prototype.mediaURL1 = "http://localhost:3050/wp/"

// Helper to check if current page is public
const isPublicPage = () => {
  const path = window.location.pathname.toLowerCase();
  return path === '/privacy-policy' || path === '/support' || path === '/login' || path === '/' || path === '/delete-account' ;
};

// Global response interceptor for auth/authorization failure redirection
axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.status === false) {
      const msg = response.data.msg || "";
      if (
        (msg.includes("auth error") ||
        msg.includes("Access denied") ||
        msg.includes("User logged out") ||
        msg.includes("user not found")) &&
        !isPublicPage()
      ) {
        localStorage.clear();
        window.location.href = "/login";
      }
    }
    return response;
  },
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403) && !isPublicPage()) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// axios.defaults.baseURL = 'http://192.168.53.241:3050'
// Vue.prototype.baseURL = "http://192.168.53.241:3050"
// Vue.prototype.mediaURL = "http://192.168.53.241:3050/u/"
// Vue.prototype.mediaURL1 = "http://192.168.53.241:3050/wp/"

// axios.defaults.baseURL = 'https://r0z2fx1p-3050.inc1.devtunnels.ms/'
// Vue.prototype.baseURL = "https://r0z2fx1p-3050.inc1.devtunnels.ms/"
// Vue.prototype.mediaURL = "https://r0z2fx1p-3050.inc1.devtunnels.ms/u/"
// Vue.prototype.mediaURL1 = "https://r0z2fx1p-3050.inc1.devtunnels.ms/wp/"

// //production
axios.defaults.baseURL = 'https://hwcapi.sarpa.co.in/'
Vue.prototype.baseURL = "https://hwcapi.sarpa.co.in/"
Vue.prototype.mediaURL = "https://hwcapi.sarpa.co.in/u/"
Vue.prototype.mediaURL1 = "https://hwcapi.sarpa.co.in/wp/"

//development
// axios.defaults.baseURL = 'https://sarpaapi.forest.kerala.gov.in/'
// Vue.prototype.baseURL = "https://sarpaapi.forest.kerala.gov.in/"
// Vue.prototype.mediaURL = "https://sarpaapi.forest.kerala.gov.in/u/"
// Vue.prototype.mediaURL1 = "https://sarpaapi.forest.kerala.gov.in/wp/"

// //local
// axios.defaults.baseURL = 'http://localhost:3050'
// Vue.prototype.baseURL = "http://localhost:3050"
// Vue.prototype.mediaURL = "http://localhost:3050/u/"
// Vue.prototype.mediaURL1 = "http://localhost:3050/wp/"


// Vue.prototype.mediaURL1 = "https://hwcapi.sarpa.co.in/wp/"


Vue.prototype.appColor = "#FF6907"

new Vue({
  router,
  vuetify,
  // socket,
  store,
  render: h => h(App)
}).$mount('#app')